module.exports = __webpack_public_path__ + "img/kommune-1868.d6b71128.svg";